import React from "react";
import "./../Styles/designerdescription.css";

function clean(value) {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();

  return ["", "null", "undefined", "n/a", "-"].includes(text.toLowerCase())
    ? ""
    : text;
}

export default function DesignerDescription({ designer, profileType }) {
  if (!designer) return null;

  const type = (
    clean(designer.profile_type) ||
    clean(profileType) ||
    "designer"
  ).toLowerCase();

  const isSketcher = type === "sketcher";
  const role = isSketcher ? "sketcher" : "designer";
  const roleTitle = isSketcher ? "Sketcher" : "Designer";

  const name = clean(designer.name);
  const skills = clean(designer.skills);
  const experience = clean(designer.experience);
  const location = clean(designer.location);

  const rawRate = clean(designer.expected_salary);
  const rate = Number(rawRate.replace(/,/g, ""));

  const formattedRate =
    rawRate && Number.isFinite(rate) && rate >= 0
      ? `₹${rate.toLocaleString("en-IN")} per hour`
      : "";

  const overview = [
    `This profile has been created for hiring enquiries.
    If you are looking to hire an embroidery ${role}${
      location ? ` in ${location}` : ""
    }, review ${name ? `${name}’s` : "this professional’s"}
    skills, experience, and work description to see whether
    they match your requirements.`,
    skills ? `Listed skills: ${skills}.` : "",
    experience ? `Listed experience: ${experience}.` : "",
    formattedRate ? `The expected rate is ${formattedRate}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className="designer-description"
      aria-label={`${roleTitle} hiring information`}
    >
      <span className="designer-description__label">
        {roleTitle.toUpperCase()} HIRING
      </span>

      <h2>
        Hire {name || `an embroidery ${role}`}
        {name ? ` — Embroidery ${roleTitle}` : ""}
      </h2>

      <p>{overview}</p>

      <h3>Find the right {role} for your work</h3>

      <p>
        {isSketcher
          ? "Discuss your requirements for motif drawing, embroidery sketches, borders, patterns, garment layouts, and artwork preparation. Confirm whether the sketcher can develop your reference concept or prepare new artwork in your preferred style."
          : "Discuss your requirements for embroidery digitizing, stitch settings, design editing, and production files. Confirm whether the designer can prepare work for your machine configuration and required embroidery techniques."}
      </p>

      <h3>Review skills and work samples</h3>

      <p>
        {isSketcher
          ? "Ask for sketching samples relevant to your project, such as floral motifs, buta artwork, lace borders, or garment compositions. Review proportions, detailing, repeat arrangements, and the clarity of artwork intended for digitizing."
          : "Ask for digitized design samples and, where available, photographs of stitched results. Review stitch quality, density, sequencing, trims, and finishing on projects similar to yours."}
      </p>

      <h3>Discuss your hiring requirements</h3>

      <p>
        {isSketcher
          ? "Share reference images, measurements with units, placement, repeat size, and the required artwork format. Agree on whether the work includes an initial sketch, colour options, final artwork, and revisions."
          : "Share reference artwork, measurements with units, fabric details, colours, hoop size, and machine requirements. Agree on the required embroidery file formats, revisions, and whether sample corrections are included."}
        {" "}
        Confirm availability, delivery deadlines, and whether you need
        regular work, an hourly arrangement, or a specific project.
      </p>

      <h3>Contact and confirm the terms</h3>

      <p>
        Use the WhatsApp button or contact information on this profile
        to discuss hiring the {role}. Confirm the hourly rate or
        project quotation, responsibilities, revisions, delivery
        schedule, and payment terms before starting the work.
      </p>

      <p className="designer-description__note">
        This {role} profile is provided for hiring enquiries.
        Skills, experience, and expected rates are supplied in the
        listing. Confirm current availability and suitability
        directly with the {role}.
      </p>
    </section>
  );
}